/**
 * Studio auth + gate parts (doc 119 §24).
 *
 * The shapes every auth and gate screen in the mock is built from: the 64
 * header with the mark and wordmark, the card on the ground, the 44 gate glyph,
 * the one notice shape and the "working, please wait" process card. Rendered
 * only on the Studio branch of a ternary — the classic components keep their
 * exact class strings, so classic cannot move.
 *
 * Styles: `frontend/src/styles/studio.css` §24.
 */
import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

export function StudioAuthShell({ children, right = null, top = false, aside = null }) {
  return (
    <div className="st-au-shell">
      {aside}
      <div className="st-au-hdr">
        <div data-ui="brand-mark" aria-label="Worship OS" className="st-au-mark">W</div>
        <span className="st-au-wm">Worship OS</span>
        {right && <span className="st-au-right">{right}</span>}
      </div>
      <div className={top ? 'st-au-page st-au-top' : 'st-au-page'}>{children}</div>
    </div>
  );
}

export function StudioNotice({ kind = 'bad', children, testid }) {
  return (
    <div className={`st-au-notice st-au-${kind}`} role={kind === 'bad' ? 'alert' : undefined} data-testid={testid}>
      {kind === 'ok' ? <CheckCircle2 className="w-4 h-4" /> : <AlertCircle className="w-4 h-4" />}
      <span>{children}</span>
    </div>
  );
}

/** The 44 glyph above a gate title, tinted by state. */
export function StudioGlyph({ icon: Icon, kind = '' }) {
  return <span className={`st-au-glyph${kind ? ` st-au-${kind}` : ''}`}><Icon /></span>;
}

/** A gate card: glyph, 22 title, one sentence, then whatever the gate offers. */
export function StudioGateCard({ icon, kind = '', title, sentence, children, foot, testid }) {
  return (
    <div className="st-au-card st-au-c" data-testid={testid}>
      <div className="st-au-head st-au-c">
        {icon && <StudioGlyph icon={icon} kind={kind} />}
        <h1 className="st-au-t">{title}</h1>
        {sentence && <p className="st-au-s">{sentence}</p>}
      </div>
      {children}
      {foot && <div className="st-au-foot">{foot}</div>}
    </div>
  );
}

/** "Working, please wait": the breathing mark, a title, a sentence, typing dots. */
export function StudioProcessCard({ title, sentence, dots = true, testid }) {
  return (
    <div className="st-au-card st-au-c">
      <div className="st-au-proc">
        <span className="st-au-breathe">W</span>
        <h1 className="st-au-t" data-testid={testid}>{title}</h1>
        {sentence && <p className="st-au-s">{sentence}</p>}
        {dots && <span className="st-au-typing"><i /><i /><i /></span>}
      </div>
    </div>
  );
}
